module.exports = __webpack_public_path__ + "media/images/paypal_2-b4829a3d02e2ad9277988295aae3b873.svg";